import { Box, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, IconButton, Tooltip, TablePagination, TextField, Link } from '@mui/material';
import { Edit, Delete, OpenInNew } from '@mui/icons-material';
import { Schedule } from '../../types';

interface Props {
  items: Schedule[]; loading: boolean; total: number; page: number; limit: number;
  onPageChange: (page: number) => void; onEdit: (item: Schedule) => void; onDelete: (id: number) => void;
}

export function SchedulesTable({ items, loading, total, page, limit, onPageChange, onEdit, onDelete }: Props) {
  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Название</TableCell>
            <TableCell>Населённый пункт</TableCell>
            <TableCell>Ссылка</TableCell>
            <TableCell>Храм</TableCell>
            <TableCell>Действия</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {items.map((item) => (
            <TableRow key={item.id} hover>
              <TableCell>{item.name}</TableCell>
              <TableCell>{item.location || '-'}</TableCell>
              <TableCell>
                {item.url
                  ? <Link href={item.url} target="_blank" rel="noopener" sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5 }}>расписание <OpenInNew fontSize="inherit" /></Link>
                  : '-'}
              </TableCell>
              <TableCell>{item.temples?.name || '-'}</TableCell>
              <TableCell>
                <Box sx={{ display: 'flex', gap: 0.5 }}>
                  <Tooltip title="Редактировать"><IconButton size="small" onClick={() => onEdit(item)}><Edit fontSize="small" /></IconButton></Tooltip>
                  <Tooltip title="Удалить"><IconButton size="small" onClick={() => onDelete(item.id)} sx={{ color: 'error.main' }}><Delete fontSize="small" /></IconButton></Tooltip>
                </Box>
              </TableCell>
            </TableRow>
          ))}
          {items.length === 0 && !loading && (
            <TableRow><TableCell colSpan={5} align="center"><Typography color="text.secondary">Данные не найдены</Typography></TableCell></TableRow>
          )}
        </TableBody>
      </Table>
      <TablePagination component="div" count={total} page={page - 1} onPageChange={(_, p) => onPageChange(p + 1)} rowsPerPage={limit} onRowsPerPageChange={() => {}} rowsPerPageOptions={[]} />
    </TableContainer>
  );
}

export function SchedulesToolbar({ search, onSearchChange }: { search: string; onSearchChange: (v: string) => void }) {
  return (
    <Box sx={{ display: 'flex', gap: 2, mb: 2, alignItems: 'center' }}>
      <TextField label="Поиск по названию/пункту" variant="outlined" size="small" value={search} onChange={(e) => onSearchChange(e.target.value)} sx={{ minWidth: 260 }} />
    </Box>
  );
}
